<script>
export default {
  props: {
    modelValue: {
      type: [String, Number],
      required: true
    },
    name: String,
    placeholder: String,
    error: String,
    showErrorMessage: {
      type: Boolean,
      default: true,
    },
    full: Boolean,
    hFull: Boolean,
    width24: Boolean,
    width14: Boolean,
    width60: Boolean,
    width72: Boolean,
    widthCustom:{type:String, default: ''},
    height11: Boolean,
    height12: Boolean,
    width52: Boolean,
    width36: Boolean,
    readonly: {
      type: Boolean,
      default: false,
    },
    disabled: Boolean,
    isNumber: Boolean,
    inputName: String,
    inputtype: String,
    maxNumber: Number,
    minNumber: Number,
    maxlength: Number,
    autoComplete: [String, Boolean],
    required: Boolean,
    lastPaddingString: {
      type: String,
      default: null,
    },
    lastInnerString: {
      type: String,
      default: null,
    },
    placeholderTextColorGray400: {
      type: Boolean,
      default: false,
    },
    isRequired: Boolean,
  },
  emits: ["update:modelValue", "afterInput", "update:rawNumber"],
  methods: {
    onNumberKeyDown(event) {
        const allowedKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab', 'Home', 'End'];

        const val = event.target.value;

        // 소수점(.)은 숫자 뒤에서만 입력 가능, 중복 검사는 input 이벤트에서 처리
        if (event.key == '.' && val.length > 0) {
            return true;
        }

        // 이전값이 0인 아닌 경우에만 0 입력허용
        if (val !== '0' && event.key === '0') {
            return true;
        }
        if (event.key >= '1' && event.key <= '9') return true;

        if (allowedKeys.includes(event.key)) return true;

        event.preventDefault();
        return false;
    },
    onDecimalInput(event) {
      let value = event.target.value.replace(/[^0-9.]/g, '');
      const parts = value.split('.');
      if (parts.length > 2) value = parts[0] + '.' + parts[1];
      if (parts[1]) {
        parts[1] = parts[1].slice(0, 2);
        value = parts.join('.'); 
      }
      
      const [intPart, decPart] = value.split('.');
      const intClean = String(parseInt(intPart, 10)); // 맨앞 0있는 경우 10진수로 변환
      const formattedInt = isNaN(intClean) ? '' : intClean.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      let formatted = '';
      if (typeof decPart !== 'undefined') {
        formatted = `${formattedInt}.${decPart}`;
      } else if (value.endsWith('.')) {
        formatted = `${formattedInt}.`;
      } else {
        formatted = formattedInt;
      }

      event.target.value = formatted;
      this.$emit('update:modelValue', formatted);

      const rawNumber = parseFloat(value);
      if (!isNaN(rawNumber)) {
        this.$emit('update:rawNumber', rawNumber);
      } else {
        this.$emit('update:rawNumber', null);
      }
    },
  }
};
</script>

<template>
  <div>
    <h1 v-if="name" class="text-sm font-semibold text-slate-800">{{ name }}
        <span class="text-red-600" v-show="isRequired && !readonly">*</span>
    </h1>
    <div :class="lastInnerString!=null ? 'relative inline-block w-full' : ''">
      <input type="text"
             :value="modelValue"
             @keydown="onNumberKeyDown"
             @input="onDecimalInput"
             @blur="$emit('afterInput', $event)"
             :placeholder="placeholder"
             :readonly="readonly"
             :disabled="disabled"
             :max="maxNumber"
             :min="minNumber"
             :name="inputName"
             :maxlength="maxlength ? maxlength : 100"
             :autocomplete="autoComplete"
             :required="required"
             class="block w-full border border-border-basic-2 rounded-2 font-body-sm-regular h-[2.75rem]"
             :class="{
                'h-11': height11,
                'h-12': height12,
                'focus:blu-text': !readonly,
                'text-right': isNumber,
                'mt-3': name,
                'border-accent-red-3': error,
                'w-96': !full && !width24 && !width14 && !width60 && !width72 && !width52 && !width36,
                'w-60': width60,
                'w-full': full,
                'h-full' : hFull,
                'w-24': width24,
                'w-14': width14,
                'w-72': width72,
                'w-52': width52,
                'w-36' : width36,
                'inline-block' : lastPaddingString !== null,
                'bg-background-basic-4 text-content-basic-2': disabled,
                'bg-background-basic-4': readonly,
                'placeholder-text-content-basic-3': placeholderTextColorGray400,
                }"
      />
      <span v-if="lastInnerString !== null" class="absolute right-3 top-1/2 -translate-y-1/2 text-content-basic-3 pointer-events-none">
          {{ lastInnerString }}
      </span>
      <span v-if="lastPaddingString !== null" class="inline-block align-middle ml-5">{{ lastPaddingString }}</span>
    </div>
    <p class="mt-4 font-caption-md-regular text-accent-red-3" v-show="error && typeof error == 'string' && showErrorMessage" >
      {{ error }}
    </p>
  </div>
</template>
<style scoped>
    .blu{
      background: #4361EE;
    }
    .blu:hover{
      background: #334cba;
    }
    .blu-text{
      color:#4361EE;
    }
.placeholder-text-color-gray-400::placeholder {
    --tw-text-opacity: 1;
    color: rgb(156 163 175 / var(--tw-text-opacity));
}

</style>